export const booleanConverter = (value: string | null): boolean =>
  value === 'true';

export const booleanOrStringConverter = (
  value: string | null
): boolean | string => {
  if (value === 'true') return true;
  if (value === null || value === 'false') return false;
  return value;
};
